import { Component, inject, viewChild } from "@angular/core";
import { RouterLink, RouterLinkActive } from "@angular/router";
import { IconComponent } from "@shared/components/atoms/icon/icon.component";
import { TranslatePipe } from "@ngx-translate/core";
import { ButtonBadgeComponent } from "@shared/components/atoms/button-badge/button-badge.component";
import { CartStateService } from "@shared/services/cart-state.service";
import { FavoriteProductsStateService } from "@shared/services/favorite-products-state.service";
import { AsyncPipe } from "@angular/common";
import { MobileCategoryDrawerComponent } from "@shared/components/organisms/mobile-category-drawer/mobile-category-drawer.component";
import { MobileAccountDrawerComponent } from "@shared/components/organisms/mobile-account-drawer/mobile-account-drawer.component";
import { CategoryService } from "@shared/services/category.service";
import { toSignal } from "@angular/core/rxjs-interop";

@Component({
  selector: "app-mobile-bottom-nav",
  imports: [
    RouterLink,
    RouterLinkActive,
    IconComponent,
    TranslatePipe,
    ButtonBadgeComponent,
    AsyncPipe,
    MobileCategoryDrawerComponent,
    MobileAccountDrawerComponent,
  ],
  templateUrl: "./mobile-bottom-nav.component.html",
  styleUrl: "./mobile-bottom-nav.component.scss",
})
export class MobileBottomNavComponent {
  private readonly cartStateService = inject(CartStateService);
  private readonly favoriteProductsStateService = inject(FavoriteProductsStateService);
  private readonly categoryService = inject(CategoryService);

  readonly cartCount$ = this.cartStateService.productsCount$;
  readonly favoriteProducts = this.favoriteProductsStateService.favoriteProducts;
  readonly navigationCategories = toSignal(this.categoryService.getAllNavigationCategories(), { initialValue: [] });

  categoryDrawer = viewChild<MobileCategoryDrawerComponent>("categoryDrawer");
  accountDrawer = viewChild<MobileAccountDrawerComponent>("accountDrawer");

  toggleCategoryMenu(): void {
    this.accountDrawer()?.close();
    this.categoryDrawer()?.toggle();
  }

  toggleAccountMenu(): void {
    this.categoryDrawer()?.close();
    this.accountDrawer()?.toggle();
  }
}
